import { useEffect, useState } from 'react';

export const useTimer = (initialToggleState: boolean) => {
  const [windowToggle, setWindowToggle] = useState<boolean>(initialToggleState);
  const [count, setCount] = useState<number>(0);
  let countdownInterval: NodeJS.Timeout | undefined;

  // biome-ignore lint/correctness/useExhaustiveDependencies: changing might break feature
  useEffect(() => {
    if (windowToggle) {
      countdownInterval = setInterval(() => {
        setCount((prevCount) => prevCount + 1);
      }, 1000);
    } else {
      setCount(0);
      clearInterval(countdownInterval);
    }

    return () => {
      clearInterval(countdownInterval);
    };
  }, [windowToggle]);

  return { windowToggle, setWindowToggle, count };
};
